import React from 'react'

import bannerImgSm from 'images/design_partnership/wildcat_hero_small.webp'

import Layout from './Components/Layout'

const heading = (
  <h2 className="cgt-legacy-heading-h4">
    A new kind of freelancing platform for 3D designers
  </h2>
)

const content = (
  <ul>
    <li>
      Earn up to $200 per delivered model
    </li>
    <li>
      Enjoy multiplier bonuses and top rates
    </li>
    <li>
      Pick the tasks you want, no bidding
    </li>
    <li>
      A constant stream of work and income
    </li>
  </ul>
)

const action = (
  <button className="cgt-button">
    Start Now!
  </button>
)

function NewWildcatBanner() {
  return (
    <div
      className="new-banner"
      style={{
        backgroundImage: `url("${bannerImgSm}")`
      }}
    >
      <Layout
        heading={heading}
        content={content}
        action={action}
        useWideContent
      />
      <a
        href="/freelance-with-us"
        className="new-banner__link"
      />
    </div>
  )
}

export default NewWildcatBanner
